<!-- 区域进度及统计页面 -->
<template>
<div class='areaRptIndexParent'>
  <v-header :headTitle='headTitle' v-on:getHeaderHeight='getHeaderHeight' :isBack='true' :pageName="pageName"></v-header>
  <div class="areaRptIndexParent-container" :style='{"background-color":tableIndex==0?"#f2f2f2":"#fff"}'>
     <v-areaRptSchedule v-if='tableIndex==0'></v-areaRptSchedule>
     <!-- <v-monitorStatistics v-else></v-monitorStatistics>  -->
     <v-areaStatistics v-if="tableIndex==1 && batch == 2021" :containerHeight='containerHeight' :topHeight='topHeight'></v-areaStatistics>
     <v-areaStatistics2023 v-if="tableIndex==1 && (batch == 2023 || batch == 2025)" :containerHeight='containerHeight' :topHeight='topHeight'></v-areaStatistics2023>
  </div>
  <v-footer v-on:changeBottomTab='changeBottomTab' :pageName='pageName'></v-footer>
  
</div>
</template>

<script>
import footer from '../../components/footer/footer.vue'
import header from '../../components/header/header'
import areaRptSchedule from './areaRptSchedule.vue'
// import monitorStatistics from './monitorStatistics.vue'
import areaStatistics from './areaStatistics.vue'  // 后续区域统计页面
import areaStatistics2023 from './areaStatistics2023.vue'


export default {
data() {
return {
  batch:'',
  containerHeight:0,
  topHeight:0,
  tableIndex:0,
  pageName: 'areaStatistics',
  headTitle:localStorage.getItem('taskName')

};
},
created() {
  this.batch = localStorage.getItem('batch')
  document.title = localStorage.getItem('taskName')
},
components: {
  'v-footer': footer,
  'v-areaRptSchedule':areaRptSchedule,
  // 'v-monitorStatistics':monitorStatistics,
  'v-areaStatistics':areaStatistics,
  'v-areaStatistics2023':areaStatistics2023,
  'v-header': header
},
methods: {
  getHeaderHeight(val){
    this.containerHeight = `calc(100vh - ${val+50}px)`  // 减号左右两边必须有空格
    this.topHeight = (val-1)+'px'
  },
  changeBottomTab(val){
    this.tableIndex = val
  }

},
}
</script>
<style lang='scss' scoped>
.areaRptIndexParent{
  display: flex;
  flex-direction: column;
  height: 100vh;
  .areaRptIndexParent-container{
    flex: 1;
    overflow: scroll;
  }
}
</style>